import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/selectors/authSelectors";
import { ROUTES } from "../../constants";

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute - redirects to dashboard if user is already authenticated
 * Used for login, registration, and other auth pages
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  // Render public content
  return <>{children}</>;
};

export default PublicRoute;
